class mobileToolbar extends HTMLElement {
    constructor() {
      super();
        let chooseOptionsBtn = document.querySelector('[data-choose-options]');
        chooseOptionsBtn.addEventListener('click',this.openModal)
        this.registerMobileToolbar();
      }
      openModal(event){
        document.querySelector('[data-product-toolbar-mobile]').classList.add('fully-opened');
        event.currentTarget.classList.add('d-none');
      }
      registerMobileToolbar(){
        let productFormPosition = document.querySelector('[data-product-form]');
        let toolbarMobile = document.querySelector('[data-product-toolbar-mobile]');
        let chooseOptionsBtn = document.querySelector('[data-choose-options]');
        window.addEventListener('scroll',()=>{
            const windowScrollY = window.scrollY;
            if(windowScrollY > productFormPosition.offsetTop){
                toolbarMobile.classList.add('semi-opened');
                if(chooseOptionsBtn.classList.contains('d-none')){
                    chooseOptionsBtn.classList.remove('d-none');
                }
            }
            if ((window.innerHeight + window.pageYOffset)+1 >= document.body.offsetHeight || windowScrollY < productFormPosition.offsetTop) {
                toolbarMobile.classList.remove("semi-opened","fully-opened",);
                // toolbarMobile.classList.remove('fully-opened');
            }
        })
      }
  }
  customElements.define("mobile-toolbar", mobileToolbar);